exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods_info .info[data-v-45306cd9]{margin-left:10px}.goods_info .info p[data-v-45306cd9]{color:#666666}.goods_info .info p[data-v-45306cd9]:first-child{color:#999999}.activity[data-v-45306cd9]{line-height:24px}.activity span[data-v-45306cd9]{width:20px;height:20px;margin-left:10px}\n", ""]);

// exports
